import {
  FilterType,
  FilterValue,
  InputType,
  SelectOption,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { useTranslation } from "@coworker/locales";
import { ALERTS_ID } from "./useAlertsFilter";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";

export const EDS_DATES_ID = "edsDates";
export const PEDS_DATES_ID = "pedsDates";

function useGenericEdsFilter({
  filterId,
  titleKey,
  allLabelKey,
  options,
  filterValues,
  enabledValue,
}: {
  filterId: string;
  titleKey: string;
  allLabelKey: string;
  options: SelectOption[];
  filterValues: FilterValue[];
  enabledValue: string;
}) {
  const { t } = useTranslation();

  const isEnabled =
    filterValues.find((f) => f.filterId === ALERTS_ID)?.value === enabledValue;

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: filterId,
      title: t(titleKey),
      options,
      enabled: isEnabled,
      defaultValue: { filterId, value: "" },
    },
    t(allLabelKey)
  );
}
export const useEdsFilter = (
  type: "eds" | "peds",
  filterValues: FilterValue[],
  options: SelectOption[]
) => {
  const config = {
    eds: {
      filterId: EDS_DATES_ID,
      titleKey: "edsDatesString",
      allLabelKey: "allEdsDatesString",
    },
    peds: {
      filterId: PEDS_DATES_ID,
      titleKey: "pedsDatesString",
      allLabelKey: "allPedsDatesString",
    },
  }[type];

  return useGenericEdsFilter({
    ...config,
    options,
    filterValues,
    enabledValue: type,
  });
};
